import FormularioMain2 from "./FormularioMain2";

const Main2 = () => {

    return ( 
        <div className="container">
          <div className="row">
            <div className="col">
              <h1>Cards</h1>
              <FormularioMain2/>
            </div>
          </div>
        </div>
     );
}
 
export default Main2;
